import React, { useEffect, useMemo, useState } from "react";
import { Tabs } from "react-simple-tabs-component";
import "react-simple-tabs-component/dist/index.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomerPricing from "./customerPricing/CustomerPricing";
import { hasPermission } from "../../helpers/utils/AccessControlUtils";
import PartnerPricing from "./partnerPricing/PartnerPricing";
import VendorPricing from "./vendorPricing/VendorPricing";
import Breadcrumb from "../../components/common/Breadcrumbs";
import FullFillmentPricing from "./fulFillmentPricing/FulFillmentPricing";


// Type Definitions
interface Crumb {
    content: string;
    url: string;
}

// Redux State Type (Customize as per your store structure)
interface RootState {
    utilDataReducer: {
        authorities: string[];
    };
}

const Accounting: React.FC = () => {
    document.title = "TGX";
    const navigate = useNavigate();

    // Breadcrumbs State
    const [crumbs] = useState<Crumb[]>([
        { content: "Home", url: "/home" },
        { content: "Product Pricing", url: "" },
    ]);

    // Get Authorities from Redux
    const authorities = useSelector(
        (state: RootState) => state.utilDataReducer?.authorities || []
    );
    const [isExport, setIsExport] = useState(false);

    // Define Tabs with Permission Checks
    const tabs = useMemo(() => {
        const result: any[] = [];

        if (hasPermission(["PRIC-V"])) {
            result.push({ label: "Customer Pricing", path: "/accounting/customer-pricing", Component: CustomerPricing });
        }
        if (hasPermission(["PTPRC-V"])) {
            result.push({
                label: "Partner Pricing",
                path: "/accounting/partner-pricing",
                Component: PartnerPricing,
            });
        }
        if (hasPermission(["VPRC-V"])) {
            result.push({
                label: "Vendor Pricing",
                path: "/accounting/vendor-pricing",
                Component: VendorPricing,
            });
        }
        if (hasPermission(["FFPRC-V"])) {
            result.push({ label: "Fulfillment Pricing", path: "/accounting/fulfillment-pricing", Component: FullFillmentPricing });
        }

        return result;
    }, []);

    return (
        <div className="user-container px-5 py-5 ">
            <Breadcrumb crumbs={crumbs} />
            <div className="mt-5 [&_.nav-tabs]:!mb-0">
                <Tabs tabs={tabs} />
            </div>
        </div>
    );
};

export default Accounting;
